import { NgModule } from '@angular/core';
import { FARRIS_COMMAND_SERVICE_MODULE_PROVIDERS } from './providers/index';
import { WfTaskHandlerModule } from '@gsp-wf/wf-task-handler';
import { WorkFlowMessage } from './work-flow/index';

@NgModule({
  providers: FARRIS_COMMAND_SERVICE_MODULE_PROVIDERS,
  imports: [
    WfTaskHandlerModule
  ],
  exports: [
    WfTaskHandlerModule
  ]
})
class CommandServicesModule {
  constructor(private workFlowMessage: WorkFlowMessage) {
    if (this.workFlowMessage) {
      this.workFlowMessage.setup();
    }
  }
}

export { CommandServicesModule };
